export const InjectEventNames = Object.freeze({
  crm: {
    activities: {
      activityCreated: 'onCrmActivityCreated',
      activityUpdated: 'onCrmActivityUpdated',
      activityDeleted: 'onCrmActivityDeleted',
    },
    flyout: {
      navigateBackward: 'onCrmFlyoutBackwardsNavigate',
      navigateForward: 'onCrmFlyoutForwardsNavigate',
    },
  },
} as const);
